export default "__VITE_ASSET__7bd05f69__"